export enum EnumTpTermo {
    SIMPLES = 0,
    COMUM = 1,
    COMPLETO = 2
}